import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { applicationsMenu, monthlyDropdownList, userActivityChart } from '../../../../Data/DashboardsData/ECommerceData'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { UserActivityTitle } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { H3, H4, LI, UL } from '../../../../AbstractElements'

export default function UserActivity() {
    return (
        <Col xxl={3} xl={6} sm={6} className="box-col-6">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={UserActivityTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="pt-0">
                    <div className="user-activity" id="UserActivity">
                        <ReactApexChart options={userActivityChart} series={userActivityChart.series} type='radialBar' height={285} />
                    </div>
                    <div className="user-activity">
                        <UL className='simple-list flex-row'>
                            {applicationsMenu.map((item) => (
                                <LI key={item.id}>
                                    <div className="applications-menu">
                                        <H3>{item.title}</H3>
                                    </div>
                                    <H4>{item.value}%</H4>
                                </LI>
                            ))}
                        </UL>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}